import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import moment from "moment";
import { map, Observable, of, tap } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { IPayload } from "../interface/filters";
import { InterviewDetail } from "../shared/modals/table-links-modal/models/interview-details";
import { ApplicationService } from "./application.service";
import { LoaderService } from "./loader.service";
import { MyUtils } from "./my-utils.service";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class SurveyService {
  endpoint = environment.csibefrontend;
  surveyDate = moment().format("YYYY-MM-DD");
  public token: string;

  constructor(
    private currentUrl: Router,
    private http: HttpClient,
    private loaderService: LoaderService,
    private utils: MyUtils,
    private applicationService: ApplicationService,
    private activatedRoute: ActivatedRoute // Add this line

  ) {
    let currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
    this.token = currentUser && currentUser.token;
  }

  // newGetInterviewDetails(
  //   brand: string,
  //   region: string,
  //   section: string,
  //   surveyRequestId: string,
  //   surveyDate: string,): Observable<any> {

  //   let _url = this.endpoint + "v5/interviewSummary";

  //   let payload: IPayload = Object.assign({});

  //   payload.question = {
  //     limit: "",
  //     locale: this.applicationService.languageSelectValue,
  //     orderByScore: "",
  //     questionCode: "",
  //     section: this.applicationService.navBarSelectValue.idItem,
  //     tab: 'INTERVIEWS-SUMMARY',
  //   };
  //   payload.extraFilters = {
  //     OrderByColumn: "surveyRequestId",
  //     Page: 1,
  //     ItemsPerPage: 1,
  //     OrderBy: "",
  //     SearchColumn: "surveyRequestId",
  //     SearchFor: surveyRequestId,
  //     Nps: "",
  //     RpCreate: "",
  //     Channel: "",
  //     lastSort: null
  //   };
  //   return this.http.post<any>(_url, payload);

  // }


  getInterviewDetails(
    brand: string,
    region: string,
    section: string,
    surveyRequestId: string,
    surveyDate: string,


  ): Observable<any> {
    let _url = this.endpoint + "v3/getInterviewDetails";

    let dateArr = surveyDate.split("/");
    let momentDate = moment(`${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`);
    let data = momentDate.format("YYYY-MM");

    let _params = new HttpParams()
      .set("brand", brand)
      .set("region", region)
      .set("section", section)
      .set("data", data)
      .set("surveyRequestId", surveyRequestId)

    const currentRoute = this.currentUrl.url;
    if (currentRoute.includes("/closed-loop")) {
      _params = _params.set("topic", "CLOSED_LOOP");
    }
    if (currentRoute.includes("/hotAlert/hot-alert-follow-up")) {
      _params = _params.set("topic", "CLOSED_LOOP");
    }

    this.loaderService.startLoader();

    return this.http.get<any>(_url, { params: _params }).pipe(
      map((response: Response) => {
        this.loaderService.stopLoader();
        if (response) {
          return JSON.stringify({ success: true, data: response });
        } else
          throw JSON.stringify({
            success: false,
            message: "(Error: Invalid Data)",
          });
      }),
      catchError((error: Response) => {
        this.loaderService.stopLoader();
        throw JSON.stringify({ success: false, status: error.status });
      })
    );
  }

  getInterviewDetailsElastic(
    brand: string,
    region: string,
    section: string,
    surveyRequestId: string,
    interviewdate: string,


  ): Observable<any> {
    let _url = this.endpoint + "v5/getInterviewDetails";

    let dateArr = interviewdate.split("/");
    let momentDate = moment(`${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`);
    let data = momentDate.format("YYYY-MM");

    let _params = new HttpParams()
      .set("brand", brand)
      .set("region", region)
      .set("section", section)
      .set("data", data)
      .set("surveyRequestId", surveyRequestId);
    const currentRoute = this.currentUrl.url;
    if (currentRoute.includes("/closed-loop")) {
      _params = _params.set("topic", "CLOSED_LOOP");
    }
    if (currentRoute.includes("/hotAlert/hot-alert-follow-up")) {
      _params = _params.set("topic", "CLOSED_LOOP");
    }

    this.loaderService.startLoader();

    return this.http.get<any>(_url, { params: _params }).pipe(
      map((response: Response) => {
        this.loaderService.stopLoader();
        if (response) {
          return JSON.stringify({ success: true, data: response });
        } else
          throw JSON.stringify({
            success: false,
            message: "(Error: Invalid Data)",
          });
      }),
      catchError((error: Response) => {
        this.loaderService.stopLoader();
        throw JSON.stringify({ success: false, status: error.status });
      })
    );
  }

  downloadExcel(el: InterviewDetail, elastic: boolean) {
    let f: IPayload = this.utils.settingsPayloadValue.payload;
    f["question"]["locale"] = this.applicationService.languageSelectValue;
    f["question"]["section"] = this.applicationService.navBarSelectValue?.idItem;
    f["question"]["tab"] = this.applicationService.navBarSelectValue?.idItem;
    let api = elastic ? "v4/exportInterviewsSummary" : "v3/exportInterviewDetails"
    return this.http
      .post(
        this.endpoint + api + `?surveyRequestId="` + el.surveyRequestId + `"`,
        f,
        {
          responseType: "blob",
        }
      )
      .pipe(
        tap((data) => {
          const file = new Blob([data], { type: "text/csv;charset=utf-8" });
          const fileURL = URL.createObjectURL(file);
          const a = document.createElement("a");
          a.href = fileURL;
          a.download = "export_Interview_detail_" + el.surveyRequestId + ".xlsx";
          a.target = "_blank";
          a.click();
        })
      );
  }


  downloadPdf(el: InterviewDetail) {

    //let _url = this.endpoint + "v3/exportInterviewDetailsPDF";

    let dateArr = el.responseDate.split("/");
    let momentDate = moment(`${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`);
    let data = momentDate.format("YYYY-MM");

    if (!el.responseDate.includes("/")) {
      let dateObject = new Date(el.responseDate);

      let year = dateObject.getFullYear();
      let month = (dateObject.getMonth() + 1).toString().padStart(2, '0');

      data = `${year}-${month}`;
    }

    let payload = {
      surveyRequestId: el.surveyRequestId,
      brand: el.brand,
      region: el.region,
      section: this.applicationService.navBarSelectValue?.idItem,
      data: data,
    }
    // .set("brand", el.brand)
    // .set("region", el.region)
    // .set("section", this.applicationService.navBarSelectValue?.idItem)
    // .set("data", data)
    // .set("surveyRequestId", el.surveyRequestId);
    const currentRoute = this.currentUrl.url;

    let params = "";

    let f: IPayload = this.utils.settingsPayloadValue.payload;
    f["question"]["locale"] = this.applicationService.languageSelectValue;
    f["question"]["section"] = this.applicationService.navBarSelectValue?.idItem;
    f["question"]["tab"] = this.applicationService.navBarSelectValue?.idItem;

    params = "surveyRequestId=" + el.surveyRequestId + "&brand=" + el.brand + "&region=" + el.region + "&section=" + this.applicationService.navBarSelectValue?.idItem + "&data=" + data;
    if (currentRoute.includes("/closed-loop") || currentRoute.includes("/hotAlert/hot-alert-follow-up")) {
      params = params + "&topic=CLOSED-LOOP";
      f["question"]["tab"] = "CLOSED-LOOP";
    }
    const sectionId = this.applicationService.navBarSelectValue.idItem;

    let actionUrl = '/roar-reports/v1/interview-details-pdf?';
    if (sectionId.toLocaleUpperCase().includes('CEC') || sectionId == 'B2E') {

      actionUrl = 'v3/exportInterviewDetailsPDF?';
    }
    return this.http
      .post(
        this.endpoint + actionUrl + params,
        f,
        {
          responseType: "blob",
        }
      )
      .pipe(
        tap((data) => {
          //console.log(data)
          const file = new Blob([data], { type: "application/octet-stream" });
          const fileURL = URL.createObjectURL(file);
          const a = document.createElement("a");
          a.href = fileURL;
          a.download = "interview_" + el.surveyRequestId + ".pdf";
          a.target = "_blank";
          a.click();
        })
      );
  }


}
